import React from 'react';

const SvgArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.947 5.85L2.909 1.134a.107.107 0 00-.173.085v9.937c0 .09.103.14.173.085l6.038-4.716a.428.428 0 000-.675z"
      fill="#8C8197"
    />
  </svg>
);

export default SvgArrowRight;
